import * as React from "react"
import { clx } from "../utils/clx"
import { VariantProps, cva } from "cva"

const TagVariants = cva({
  base: "whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset",
  variants: {
    color: {
      green: "text-green-dark bg-green-lighter ring-green-dark/20",
      grey: "text-ui-fg-subtle bg-grey-20 ring-grey-60/20",
      teal: "text-teal-dark bg-teal-lighter ring-teal-dark/20",
      red: "text-red-dark bg-red-lighter ring-red-dark/20",
      orange: "text-orange-dark bg-orange-lighter ring-orange-dark/20",
    },
  },
  defaultVariants: {
    color: "green",
  },
})

export interface TagProps
  extends Omit<React.ComponentPropsWithoutRef<"span">, "color">,
    VariantProps<typeof TagVariants> {}

/**
 * This component is based on the span element and supports all of its props
 */
const Tag = React.forwardRef<HTMLSpanElement, TagProps>(
  (
    {
      children,
      className,
      /**
       * The status's color.
       */
      color = "green",
      ...props
    }: TagProps,
    ref
  ) => {
    return (
      <span
        ref={ref}
        className={clx(TagVariants({ color }), className)}
        {...props}
      >
        {children}
      </span>
    )
  }
)
Tag.displayName = "Tag"

export { Tag }
